export default __webpack_public_path__ + "static/media/svg-bio.9d8a06c9.svg";